import { useFind } from 'src/api/APIHooks';
import { get } from 'lodash';

const useZcodes = (feeScheduleProgramId, payerId, isZcodeAssociationForced) => {
  const { data: response } = useFind(
    'zcode',
    { fee_schedule_program: feeScheduleProgramId, payer: payerId },
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!feeScheduleProgramId && !!payerId && !isZcodeAssociationForced,
      },
    },
  );

  const data = get(response, 'data.data', []);
  return { data };
};

export default useZcodes;
